import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import './style.css';

const dateRangeText = block => {
  const endTime = moment(block.endTime);
  if (endTime.isSame(moment(block.endTime).startOf('day'))) {
    // If block end time is start of day, we really mean to block the entire previous day
    endTime.subtract(1, 'minutes');
  }
  return `${moment(block.startTime).format('MMM DD')} - ${endTime.format('MMM DD, YYYY')}`;
};

const timeRangeText = block => {
  const startText = moment(block.startTime).format('h:mm A');
  const endText = moment(block.endTime).format('h:mm A');
  return startText === '12:00 AM' && endText === '12:00 AM' ? 'All day' : `${startText} - ${endText}`;
};

const BlockTableRow = ({
  block, header, isEmpty, onDelete, /* onSelect, selectedBlockId */
}) => (isEmpty ? (
  <div className="block-table-row d-flex align-items-center justify-content-center">
    No blocks
  </div>
) : (
  <div
    className={classnames(
      'block-table-row d-flex align-items-center px-2 px-sm-4 px-xl-5',
      {
        'block-table-row--header': header
      },
      {
        'block-table-row--body': !header
      }
      /* {
                      'block-table-row--selected': !header && selectedBlockId === block.id
                    } */
    )}
    /* onClick={() => onSelect && onSelect(block)} */
  >
    <div className="block-table-col block-table-col--status pl-3">
      {header ? 'Status' : 'Blocked'}
    </div>
    <div className="block-table-col block-table-col--date">
      {header ? 'Date(s)' : dateRangeText(block)}
    </div>
    <div className="block-table-col block-table-col--time">
      {header ? 'Time(s)' : timeRangeText(block)}
    </div>
    <div className="block-table-col block-table-col--action">
      {!header && block.googleEventId && (
        <img className="provider-icon" src="/assets/google.png" alt="google" />
      )}
      {!header && block.microsoftEventId && (
        <img className="provider-icon" src="/assets/microsoft.png" alt="microsoft" />
      )}
      {!header && !block.googleEventId && !block.microsoftEventId && (
        <div
          className="block-table-col__close btn-cursor"
          onClick={event => {
            event.stopPropagation();
            onDelete && onDelete(block.id);
          }}
        />
      )}
    </div>
  </div>
));

export default BlockTableRow;



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Availability/Specific/BlockTableRow/index.js